<template>
  <div>
    <div class="be-room-card-skel" v-for="i in count" :key="i">
      <div class="be-room-card-skel__grid">
        <aside class="be-room-card-skel__sidebar">
          <div class="be-room-card-skel__gallery">
            <b-skeleton-img no-aspect width="100%" height="200px" class="be-room-card-skel__gallery-main" />
            <div class="be-room-card-skel__gallery-thumbs">
              <b-skeleton-img no-aspect width="100%" height="64px" v-for="t in 3" :key="t" />
            </div>
          </div>
          <b-skeleton width="75%" height="20px" class="be-room-card-skel__name" />
          <div class="be-room-card-skel__specs">
            <b-skeleton width="45%" height="15px" class="mb-2" v-for="s in 3" :key="s" />
          </div>
          <b-skeleton width="100%" height="38px" />
        </aside>

        <div class="be-room-card-skel__rates">
          <div class="be-room-card-skel__rates-head">
            <div>Benefits</div>
            <div class="text-center">Guest</div>
            <div class="text-center">Total</div>
            <div class="text-center">Price</div>
          </div>

          <div class="be-room-card-skel__rate" v-for="r in rows" :key="r">
            <b-skeleton width="45%" height="18px" class="be-room-card-skel__rate-name" />

            <div class="be-room-card-skel__col be-room-card-skel__col--benefits">
              <b-skeleton width="90%" height="14px" class="mb-2" v-for="l in 4" :key="l" />
            </div>

            <div class="be-room-card-skel__col be-room-card-skel__col--guest">
              <b-skeleton width="80%" height="14px" class="mx-auto" />
            </div>

            <div class="be-room-card-skel__col be-room-card-skel__col--room">
              <b-skeleton width="64px" height="34px" class="ml-auto" />
            </div>

            <div class="be-room-card-skel__col be-room-card-skel__col--price">
              <b-skeleton width="45%" height="24px" class="ml-auto" />
            </div>

            <div class="be-room-card-skel__actions">
              <b-skeleton width="100%" height="38px" />
              <b-skeleton width="100%" height="38px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeRoomCardSkeleton',
  props: {
    count: {
      type: Number,
      default: 2
    },
    rows: {
      type: Number,
      default: 2
    }
  }
};
</script>

<style scoped>
/* Mirrors BeRoomCard.vue / room-card/RoomCardSidebar.vue / room-card/RoomCardRateRow.vue
   so the loading state doesn't jump/reflow once real data replaces it. */
.be-room-card-skel {
  background: #f4f5f7;
  border: 1px solid #d5d9e0;
  border-radius: var(--be-v3-radius, 12px);
  padding: 16px;
  margin-bottom: 20px;
  --be-v3-rate-grid: minmax(0, 2.2fr) minmax(72px, 0.6fr) minmax(78px, 0.6fr) minmax(158px, 1.4fr);
}
.be-room-card-skel__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.be-room-card-skel__sidebar {
  background: #fff;
  border: 1px solid #d5d9e0;
  border-radius: var(--be-v3-radius, 12px);
  padding: 12px;
  align-self: start;
}
.be-room-card-skel__gallery {
  margin: -12px -12px 0;
}
.be-room-card-skel__gallery-main {
  border-radius: var(--be-v3-radius, 12px) var(--be-v3-radius, 12px) 0 0;
  overflow: hidden;
}
.be-room-card-skel__gallery-thumbs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  margin-top: 4px;
}
.be-room-card-skel__name {
  margin: 14px 0 12px;
}
.be-room-card-skel__specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 14px;
}
.be-room-card-skel__rates {
  background: #fff;
  border: 1px solid #d5d9e0;
  border-radius: var(--be-v3-radius, 12px);
  padding: 4px 16px;
}
.be-room-card-skel__rates-head {
  display: none;
}
.be-room-card-skel__rate {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 0 20px;
  border-bottom: 1px solid #d5d9e0;
}
.be-room-card-skel__rate:last-child {
  border-bottom: none;
}
.be-room-card-skel__rate-name {
  grid-column: 1 / -1;
  grid-row: 1;
  margin: 22px 0 12px !important;
}
.be-room-card-skel__col--benefits {
  grid-column: 1 / -1;
  grid-row: 2;
  padding: 16px 0 0;
}
.be-room-card-skel__col--price {
  grid-column: 1 / -1;
  grid-row: 3;
  padding: 4px 0 16px;
}
.be-room-card-skel__col--guest,
.be-room-card-skel__col--room {
  grid-row: 4;
  padding: 14px 10px;
  border-top: 1px solid #e3e6eb;
  border-bottom: 1px solid #e3e6eb;
}
.be-room-card-skel__col--guest {
  grid-column: 1;
}
.be-room-card-skel__col--room {
  grid-column: 2;
  border-left: 1px solid #e3e6eb;
}
.be-room-card-skel__actions {
  grid-column: 1 / -1;
  grid-row: 5;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding-top: 16px;
}
@media screen and (min-width: 992px) {
  .be-room-card-skel__grid {
    grid-template-columns: clamp(190px, 20vw, 260px) minmax(0, 1fr);
    align-items: start;
  }
  .be-room-card-skel__sidebar {
    position: sticky;
    top: 100px;
  }
  .be-room-card-skel__gallery-main {
    height: 170px !important;
  }
  .be-room-card-skel__rates {
    padding: 0;
  }
  .be-room-card-skel__rates-head {
    display: grid;
    grid-template-columns: var(--be-v3-rate-grid);
    background: #eef0f4;
    border-bottom: 1px solid #d5d9e0;
    border-radius: var(--be-v3-radius, 12px) var(--be-v3-radius, 12px) 0 0;
    font-weight: 800;
    color: #1a1a2e;
    font-size: 0.75rem;
    line-height: 1.4;
  }
  .be-room-card-skel__rates-head > div {
    padding: 18px 12px;
    min-width: 0;
  }
  .be-room-card-skel__rates-head > div + div {
    border-left: 1px solid #d5d9e0;
  }
  .be-room-card-skel__specs {
    grid-template-columns: 1fr;
  }
  .be-room-card-skel__rate {
    grid-template-columns: var(--be-v3-rate-grid);
    padding: 0;
  }
  .be-room-card-skel__rate-name {
    margin: 20px 16px 14px !important;
    min-width: 0;
  }
  .be-room-card-skel__col {
    padding: 20px 12px;
    min-width: 0;
  }
  .be-room-card-skel__col + .be-room-card-skel__col {
    border-left: 1px solid #e3e6eb;
  }
  .be-room-card-skel__col--benefits {
    grid-column: 1;
    grid-row: 2 / 4;
  }
  .be-room-card-skel__col--guest {
    grid-column: 2;
    grid-row: 2 / 4;
    border-top: none;
    border-bottom: none;
  }
  .be-room-card-skel__col--room {
    grid-column: 3;
    grid-row: 2 / 4;
    border-top: none;
    border-bottom: none;
  }
  /* the qty control is right-aligned on mobile and centred on desktop, so pair the
     template's ml-auto with an auto right margin here */
  .be-room-card-skel__col--room > * {
    margin-right: auto;
  }
  .be-room-card-skel__col--price {
    grid-column: 4;
    grid-row: 2;
    padding-bottom: 0;
  }
  .be-room-card-skel__actions {
    grid-column: 4;
    grid-row: 3;
    display: block;
    padding: 8px 12px 20px;
    border-left: 1px solid #e3e6eb;
  }
  .be-room-card-skel__actions > * {
    max-width: 200px;
    margin-left: auto;
  }
  .be-room-card-skel__actions > * + * {
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeRoomCardSkeleton.vue